import { combineReducers } from "@reduxjs/toolkit";
import {
  changePasswordReducer,
  getAllUsersReducer,
  getInstructorProfileReducer,
  getPopularInstructorReducer,
  updateProfileReducer,
  updateUserActiveReducer,
} from "./slices";
import { getProfileReducer } from "./slices/getProfile";

const userReducer = combineReducers({
  profile: getProfileReducer,
  profileUpdating: updateProfileReducer,
  passwordChanging: changePasswordReducer,
  getPopularInstructor: getPopularInstructorReducer,
  getInstructorProfile: getInstructorProfileReducer,
  allUsers: getAllUsersReducer,
  updateUser: updateUserActiveReducer,
});

export { userReducer };
